// Lucide icon: archive (https://lucide.dev/icons/archive)
import { Archive } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconArchive = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Archive />
    </IconComponentStyled>
  )
}
